"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardinalityToJSON = exports.CardinalityFromJSONTyped = exports.CardinalityFromJSON = exports.Cardinality = void 0;
/**
 * Defines the number of elements that may exist in a given profile.  singleton implies that the profile may have at most one item in the profile (that item must have the 'instance' identifier.  multiple implies that the profile may have zero or more items (each item must have a unique identifier within that profile)
 * @export
 */
exports.Cardinality = {
    Singleton: 'singleton',
    Multiple: 'multiple'
};
function CardinalityFromJSON(json) {
    return CardinalityFromJSONTyped(json, false);
}
exports.CardinalityFromJSON = CardinalityFromJSON;
function CardinalityFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.CardinalityFromJSONTyped = CardinalityFromJSONTyped;
function CardinalityToJSON(value) {
    return value;
}
exports.CardinalityToJSON = CardinalityToJSON;
